import {toggleRows} from './ExpandableRows';

export const expandHistoryHash = () => {
    const hash = window.location.hash;

    if (!hash || !hash.startsWith('#history-')) {
        return;
    }

    const row = document.querySelector(hash);

    if (!row) {
        return;
    }

    const expandKeys = new Set();

    if (row.dataset.expandableRow) {
        expandKeys.add(row.dataset.expandableRow);
    }

    if (row.classList.contains('history-group-row')) {
        let sibling = row.previousElementSibling;

        while (sibling && sibling.classList.contains('history-group-row')) {
            sibling = sibling.previousElementSibling;
        }

        if (sibling?.dataset.expandableRow) {
            expandKeys.add(sibling.dataset.expandableRow);
        }
    }

    for (const key of expandKeys) {
        const handle = document.querySelector(`[data-expandable-rows="${key}"]`);

        if (handle && !handle.hasAttribute('data-expanded')) {
            toggleRows(handle);
        }
    }
};
